/* src/app/shared/components/accordion/accordion.component.css */
.accordion-item {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  margin-bottom: 1rem;
}
.accordion-item::marker {
  color: transparent;
}
.accordion-header {
  display: flex;
  padding: 12px 18px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 12px 12px 0px 0px;
  border: 2px solid #373737;
  background: #004c4a;
  color: #fff;
  font-family: Outfit;
  font-size: 1.143rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  box-sizing: border-box;
}
.accordion-header:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.accordion-header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.collapsed-header {
  border-radius: 12px;
}
.toggle-button {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 108px;
  background: rgba(255, 255, 255, 0.58);
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.12);
  border: none;
  cursor: pointer;
}
.accordion-collapse {
  border-radius: 12px;
}
.accordion-body {
  display: flex;
  padding: 12px 18px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 0px 0px 12px 12px;
  border-right: 2px solid #a8a8a8;
  border-bottom: 2px solid #a8a8a8;
  border-left: 2px solid #a8a8a8;
  background: #fdfdfd;
}
:host ::ng-deep .accordion-body > * {
  width: 100% !important;
}
/*# sourceMappingURL=accordion.component-VBAGUEAA.css.map */
